import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField={
  vendorCode:{
    name: "vendorCode",
    label: "Vendor Code",
    type: "text",
    errorMsg: "Vendor Code is required",
    required: true,
    //disabled: true,
    editable:false,
    maxLength: 20,
  },
  customerCode:{
    name: "customerCode",
    label: "Customer Code",
    type: "text",
    errorMsg: "Customer Code is required",
    required: true,
    disabled: true,
    maxLength: 20,
  },
  vendorName:{
    name: "vendorName",
    label: "Vendor Name",
    type: "text",
    maxLenght: 100,
  },
  vendShortName:{
    name: "vendShortName",
    label: "Vendor Short Name",
    type: "text",
    maxLength: 30,
  },
  isDefault:{
    name: "isDefault",
    label: "Set To Default Vendor",
    type:"switch",
    default:false
  },
}
const{vendorCode,customerCode,vendorName,vendShortName,isDefault}=formField

export const form = {
  formId: "new-vendor-form",
  formRender: [
    [
      vendorCode
    ],
    [
      customerCode
    ],
    [
      vendorName
    ],
    [
      vendShortName
    ],
    [
      isDefault
    ],
  ],
};


export const initialValues = getInitialValues(formField);


export const vendorValidations = Yup.object().shape({
  [vendorCode.name]: Yup.string().nullable().max(20).required(vendorCode.errorMsg),
  [customerCode.name]: Yup.string().nullable().max(20).required(customerCode.errorMsg),
  [vendorName.name]: Yup.string().nullable().max(20),
  [vendShortName.name]: Yup.string().nullable().max(20),
});
